<template>
    <div class="ma-4">
        <v-snackbar v-model="msg" top>
            {{ text }}
            <v-btn color="pink" text @click="msg = false"> Close</v-btn>
        </v-snackbar
        >
        <ClientNav/>
        <v-row dense>
            <v-col cols="12" lg="3" xl="2">
                <ClientSide/>
            </v-col>
            <v-col cols="12" lg="9" xl="10">
                <v-card>
                    <v-tabs v-model="tab">
                        <v-tabs-slider color="yellow"></v-tabs-slider>
                        <v-tab v-for="item in items" :key="item">
                            {{ item }}
                        </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tab">
                        <v-tab-item v-for="(item, i) in items" :key="item">
                            <template>
                                <v-card class="pa-2" outlined tile height="100%">
                                    <!-- <v-card class="mb-2 .d-none .d-sm-flex">
                          <div @click="page = 'main'" class="ma-2 blue">Main</div>
                          <div @click="page = 'reports'" class="ma-2 blue">Reports</div>
                        </v-card> -->
                                    <div v-if="page === 'main'">
                                        <v-data-table
                                            :headers="i === 0 ? headers : discontinuedHeaders"
                                            :items="i === 0 ? medications : discontinuedMedications"
                                            :loading="isLoading"
                                            loading-text="Loading Medications"
                                            :search="search"
                                            height="578"
                                            group-asc
                                            sort-by="Medication"
                                            sort-asc
                                            :items-per-page="-1"
                                        >
                                            <template v-slot:top row wrap>
                                                <v-toolbar flat color="white">
                                                    <v-toolbar-title>{{
                                                            i === 0 ? "Medication" : "Discontinued Medications"
                                                        }}
                                                    </v-toolbar-title>
                                                    <v-divider class="mx-4" inset vertical></v-divider>
                                                    <v-spacer></v-spacer>
                                                    <v-text-field
                                                        v-model="search"
                                                        clearable
                                                        flat
                                                        solo-inverted
                                                        hide-details
                                                        prepend-inner-icon="search"
                                                        label="search"
                                                        class="search desktop"
                                                    ></v-text-field>
                                                    <v-spacer></v-spacer>

                                                        <template  v-if="!$vuetify.breakpoint.smAndDown">
                                                            <v-menu offset-y>
                                                                <template v-slot:activator="{ attrs, on }">
                                                                    <v-btn
                                                                        class="white--text mb-2 mr-3"
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        color="blue-grey"
                                                                        :loading="actionInProgress"
                                                                        :disabled="actionInProgress"
                                                                    >
                                                                        actions
                                                                        <v-icon right dark> mdi-tray-arrow-up</v-icon>
                                                                    </v-btn>
                                                                </template>

                                                                <v-list class="pa-0">
                                                                    <v-list-item
                                                                        v-for="(item, index) in actions"
                                                                        :key="index"
                                                                        link
                                                                    >
                                                                        <v-list-item-title
                                                                            v-text="item"
                                                                            @click="onSelectAction(item)"
                                                                        ></v-list-item-title>
                                                                    </v-list-item>
                                                                </v-list>
                                                            </v-menu>
                                                            <v-btn
                                                                v-if="!userRole"
                                                                color="#2b3990"
                                                                dark
                                                                class="mb-2 testButton"
                                                                @click="showAdd()"
                                                            >
                                                                <v-icon left>add</v-icon>
                                                                Add Medication
                                                            </v-btn
                                                            >
                                                        </template>
                                                </v-toolbar>
                                                <v-text-field
                                                    v-model="search"
                                                    clearable
                                                    flat
                                                    solo-inverted
                                                    hide-details
                                                    prepend-inner-icon="search"
                                                    label="search"
                                                    class="mobile ml-5 mr-5 mb-3 mt-3"
                                                ></v-text-field>
                                            </template>

                                            <template v-slot:item.actions="{ item, copy=true }">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            v-show="$vuetify.breakpoint.mdAndUp"
                                                            dense
                                                            color="light-blue darken-4"
                                                            dark
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            class="mr-1"
                                                            @click="viewMedication(item)"
                                                        >
                                                            mdi-eye
                                                        </v-icon>
                                                    </template>
                                                    <span>View Medication</span>
                                                </v-tooltip>
                                                <v-tooltip bottom v-if="i === 0 && !userRole">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            v-show="$vuetify.breakpoint.mdAndUp"
                                                            dense
                                                            color="yellow darken-4"
                                                            dark
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            @click="viewMedication(item, copy)"
                                                        >
                                                            mdi-content-copy
                                                        </v-icon>
                                                    </template>
                                                    <span>Copy Medication</span>
                                                </v-tooltip>

                                                <div v-show="$vuetify.breakpoint.smAndDown"
                                                    :class="$vuetify.breakpoint.smOnly ? 'pa-2' : ''">
                                                    <v-btn
                                                        v-show="$vuetify.breakpoint.smAndDown"
                                                        outlined
                                                        dense
                                                        color="light-blue darken-4"
                                                        dark
                                                        class="mr-2"
                                                        :class="$vuetify.breakpoint.smOnly ? 'mb-2 pa-2' : ''"
                                                        small
                                                        @click="viewMedication(item)"
                                                    >
                                                        edit
                                                    </v-btn>
                                                    <v-btn
                                                        v-show="$vuetify.breakpoint.smAndDown"
                                                        v-if="!userRole"
                                                        outlined
                                                        dense
                                                        color="yellow darken-4"
                                                        dark
                                                        small
                                                        @click="viewMedication(item, copy)"
                                                    >
                                                        copy
                                                    </v-btn>
                                                </div>

                                            </template>
                                            <template v-slot:no-data>
                                                <v-btn
                                                    color="#2b3990"
                                                    class="white--text"
                                                    @click="getMedication()"
                                                >Reset
                                                </v-btn
                                                >
                                            </template>
                                        </v-data-table>
                                    </div>
                                </v-card>
                            </template>
                        </v-tab-item>
                    </v-tabs-items>
                </v-card>

                <v-layout v-if="page === 'reports'">
                    <div id="chart">
                        <iframe
                            style="background: #FFFFFF;border: none;border-radius: 2px;box-shadow: 0 2px 10px 0 rgba(70, 76, 79, .2);"
                            width="640"
                            height="480"
                            src="https://charts.mongodb.com/charts-project-0-jtnop/embed/charts?id=c8a6564c-c936-42e4-b87d-89998a14befe&theme=light&autoRefresh=true&maxDataAge=60&attribution=false"
                        ></iframe>
                    </div>
                </v-layout>
            </v-col>
        </v-row>

        <EndedMedicationsDialog
            :dialog.sync="endedDialog"
            :medications="endedMeds"
        />

        <OptionMenu :onAction="handleAction" :showActions="showActions"/>

        <Foot/>
    </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import ClientNav from "../../components/ClientNav";
import ClientSide from "../../components/ClientSide";
import Foot from "../../components/Footer";
import EndedMedicationsDialog from "@/components/medications/EndedMedicationsDialog.vue";


const url = require("../../client_config/config").url;
import moment from "moment";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import reports from "@/mixins/reports";
import {mapActions} from "vuex";
import download from "downloadjs";

//Menu
import OptionMenu from "@/components/OptionMenu";

// constant
import schedule from "../../constants/ScheduleTime"
import Swal from "sweetalert2";

let MORNING = schedule.MORNING()
let AFTERNOON = schedule.AFTERNOON()
let EVENING = schedule.EVENING()
let EVENING2 = schedule.EVENING2()


export default {
    components: {
        ClientNav,
        ClientSide,
        Foot,
        ValidationProvider,
        ValidationObserver,
        EndedMedicationsDialog,
        OptionMenu
    },
    mixins: [reports],
    data: function () {
        return {
            headers: [
                {
                    text: "Medication Name",
                    align: "start",
                    sortable: true,
                    value: "Medication",
                },
                {text: "Med Class", value: "MedClass"},
                {text: "Prescribed By", value: "PrescribedBy.Name"},
                {text: "Physician Instructions", value: "Instructions", width: "20%"},
                {text: "Admin Time", value: "AdminTime"},
                {text: "RX", value: "RXNumber"},
                // { text: "Order Fill/Refill", value: "Refill" },
                {text: "Actions", value: "actions", sortable: false},
            ],

            discontinuedHeaders: [
                {
                    text: "Medication Name",
                    align: "start",
                    sortable: true,
                    value: "Medication",
                },
                {text: "Med Class", value: "MedClass"},
                {text: "Prescribed By", value: "PrescribedBy.Name"},
                {text: "Physician Instructions", value: "Instructions", width: "20%"},
                {text: "Admin Time", value: "AdminTime"},
                {text: "RX", value: "RXNumber"},
                {text: "Discontinued Date", value: "DiscontinuedStatus.date"},
                {text: "Discontinued By", value: "discontinuedBy"},
                {text: "Actions", value: "actions", sortable: false},
            ],

            tab: null,
            items: ["Medications", "Discontinued Medications"],
            isActive: false,
            page: "main",
            e1: 1,
            msg: false,
            text: "",
            search: "",
            medications: [],
            discontinuedMedications: [],
            users: [],
            tempData: [],
            units: [],
            staff: localStorage.getItem("Name"),
            providers: [],
            times: false,
            userID: localStorage.getItem("userID"),
            clientID: this.$route.params.clientID,
            prn: "",
            adminTime: [],
            titleForm: "New Medication",
            inventories: [],
            diagnoses: [],
            requiredField: [(v) => !!v || "This is required"],
            isLoading: true,
            isIndefinite: true,
            providerId: null,
            actions: ["Print", "Download"],
            actionInProgress: false,
            showActions: {
                add: true,
                print: true,
                download: true
            },
            endedDialog: false,
            endedMeds: [],
        };
    },

    computed: {
        formTitle() {
            return this.editedIndex !== 1 ? "New Item" : "Edit Item";
        },
        client() {
            return {
                name: this.$store.state.clients?.client?.Name,
            };
        },
        userRole() {
            return localStorage.getItem("userRole") === 'Auditor'
        }
    },

    watch: {
        userRole(newVal) {
            this.showActions.add = !newVal; 
        }
    },

    created() {
        this.clientID = this.$route.params.clientID;
        this.getMedication();
        this.getUnits();
        this.getProviders();
        this.getInventories();
        this.getDiagnoses(this.clientID);
        this.adminTime = this.adminTime.concat(EVENING2, MORNING, AFTERNOON, EVENING, "PRN")
    },

    mounted(){
        this.showActions.add = !this.userRole;
    },

    methods: {

        ...mapActions({
            getClientProviders: "clientProviders/getItem",
            generateDynamicReport: "reports/generateDynamicReport",
        }),

        initialize() {
            this.Medications = [];
        },

        viewMedication(item, copy) {
            if (item) {
                console.log({ item });

                const id = item._id;
                const query = copy ? { copyMedication: 'true' } : { createMedication: 'false' };

                this.$router.push({
                    path: `/medications/${this.clientID}/update-medication/${id}`,
                    query: query,
                });
            }
        },

        getUnits: function () {
            axios.get(`${url}/units`).then(async (res) => {
                this.units = res.data.units;
            });
        },


        async getProviders() {
            const response = await this.getClientProviders(this.clientID);
            this.providers = response.data.sort((a, b) => {
                return a.Provider.Name.localeCompare(b.Provider.Name)
            });

        },

        showAdd() {

            this.$router.push({ path: `/medications/${this.clientID}/add-medication`,
                query: { createMedication: 'true' } });

            // this.titleForm = "New Medication";
            // this.newMedications = true;
            // this.editMedications = false;
            // this.isCopy = true;
        },

        deleteMedication(item) {
            const id = item._id;
            confirm("Are you sure you want to delete this medication?") &&
            this.medicationDelete(id);
        },

        medicationDelete(id) {
            let UrlNotification = this.$router.history.current.path.replace("/", "");
            axios
                .delete(`${url}/medications/${id}/${ClientID}/${UrlNotification}`)
                .then((response) => {
                    this.getMedication();
                    if (response.status === 400) {
                        response.json().then(function (data) {
                            return data.msg;
                        });
                    }
                    this.msg = true;
                    this.text = "The medication has been deleted successfully.";
                });
        },


    checkMedicationEndDates(medications) {
      const endedMeds = [];
      const currentDate = new Date();

      medications.forEach((medication) => {
        if (
          medication.IsActive === true &&
          medication.IsIndefinite === false &&
          medication.EndDate &&
          new Date(medication.EndDate) < currentDate
        ) {
          endedMeds.push({
            id: medication._id,
            name: medication.Medication,
            endDate: moment(medication.EndDate).format("YYYY-MM-DD"),
            isActive: medication.IsActive,
          });
        }
      });

      return endedMeds;
    },

    processMedications() {
      this.medications = [];
      this.discontinuedMedications = [];

      this.tempData.forEach((medication) => {
        ({
          name: medication.Medication,
          isActive: medication.IsActive,
          isIndefinite: medication.IsIndefinite,
          endDate: medication.EndDate,
        });
        if (medication.IsActive) {
          this.medications.push(medication);
          return;
        }

        if (
          medication.IsIndefinite === true ||
          medication.IsIndefinite === undefined
        ) {
          return;
        }

        if (
          medication.DiscontinuedStatus &&
          medication.DiscontinuedStatus.date
        ) {
          medication.DiscontinuedStatus.date = moment(
            medication.DiscontinuedStatus.date
          ).format("YYYY-MM-DD hh:mm A");
        } else if (medication.updatedAt) {
          medication.DiscontinuedStatus = {
            date: moment(medication.updatedAt).format("YYYY-MM-DD hh:mm A"),
          };
        } else {
          medication.DiscontinuedStatus = null;
        }

        this.discontinuedMedications.push(medication);
      });
    },

    async getMedication() {
      this.isLoading = true;
      try {
        const response = await axios.get(
          `${url}/medications/all/${this.clientID}`
        );
        this.tempData = response.data.medications;

        const endedMeds = this.checkMedicationEndDates(this.tempData);

        if (endedMeds.length > 0) {
          this.endedMeds = endedMeds;
          await this.handleDiscontinueAll()
          this.endedDialog = true;
        }

        this.processMedications();
      } catch (error) {
        console.error("Error fetching medications:", error);
      } finally {
        this.isLoading = false;
      }
    },
    
    async handleDiscontinueAll() {
      try {
        await Promise.all(
          this.endedMeds.map((med) =>
            axios.put(`${url}/medications/status/${med.id}`, {
              IsActive: false,
            })
          )
        );

        await this.getMedication();
      } catch (error) {
        console.error("Error discontinuing medications:", error);
      } finally {
        this.endedDialog = false;
      }
    },

        getInventories: function () {
            axios
                .get(`${url}/medicationInventory/item/${this.clientID}`)
                .then((res) => {
                    this.inventories = res.data.client;
                    this.inventories.sort((a, b) => a.Medication.localeCompare(b.Medication))
                });
        },


        getDiagnoses(id) {
            axios.get(`${url}/diagnoses/client/${id}`).then((res) => {
                this.diagnoses = res.data.diagnoses;
            });
        },

        async onSelectAction(action) {
            try {
                this.actionInProgress = true

                let data = {
                    query: {
                        name: this.client.name,
                    },
                    endpoints: `medications/print/${this.clientID}`,
                    dynamic: true
                }

                if (action === 'Print') {
                    await this.getReport(data)
                    this.actionInProgress = false
                } else {
                    const response = await this.generateDynamicReport(data)
                    download(response.data, `${this.client.name}-medication.pdf`, "application/pdf");
                    this.actionInProgress = false
                }

            } catch (e) {
                this.msg = true
                this.text = "An error occured"
                this.actionInProgress = false
            }

        },

        handleAction(action) {
            switch (action) {
                case 'add':
                    this.$router.push({
                        path: `/medications/${this.clientID}/add-medication`,
                        query: { createMedication: 'true' }
                    })
                    break;
                case 'print':
                    this.onSelectAction('Print')
                    break;
                case 'download':
                    this.onSelectAction('Download')
                    break;
                default:
                    console.error(`Unknown action: ${action}`);
            }
        }
    },
};
</script>
<style>
#chart {
    margin-left: auto;
    margin-right: auto;
}

@media only screen and (min-width: 1200px) {
    .v-text-field.mobileSearch {
        display: none;
    }
}

@media only screen and (min-width: 766px) {
    .v-text-field.mobileSearch {
        display: none;
    }

    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    /* .v-text-field.mobileSearch {
        display: none;
      } */
    .desktop {
        display: none;
    }
}

@media only screen and (max-width: 480px) {
    /* .v-data-table {
      margin: 20px;
    }
    .v-toolbar-title {
      width: 100%;
    }
    .v-text-field.search {
      display: none;
    }
    .v-text-field.mobileSearch {
      display: block;
      padding-right: 30px;
      padding-left: 30px;
      padding-bottom: 0px;
      margin-bottom: 0px;
    } */
}
</style>
